import React from "react";
import staffMembers from "../data/editorData.json";
import StaffCard from "./StaffCard";
// import "./AboutUs.css"; // Removing as styles are now handled by Tailwind

const editors = staffMembers.filter((section) => section.section === "editor");
const business = staffMembers.filter(
  (section) => section.section === "business"
);

const AboutUs = () => {
  return (
    <>
      <title>Our Staff</title>
      <div className="max-w-7xl mx-auto px-4 py-12">
        <h1 className="text-4xl font-bold text-center mb-12">Our Staff</h1>
        
        <div className="mb-16">
          <h2 className="text-2xl font-semibold text-center py-6">Editors</h2>
          <hr className="border-t border-gray-200 mb-8" />
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {editors.map((staffMember) => (
              <div key={staffMember.id}>
                <StaffCard
                  id={staffMember.id}
                  staffMember={staffMember}
                ></StaffCard>
              </div>
            ))}
          </div>
        </div>

        <div className="mb-16">
          <h2 className="text-2xl font-semibold text-center py-6">Business</h2>
          <hr className="border-t border-gray-200 mb-8" />
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {business.map((staffMember) => (
              <div key={staffMember.id}>
                <StaffCard
                  id={staffMember.id}
                  staffMember={staffMember}
                ></StaffCard>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default AboutUs;
